export class SaveColumnsReorder {
  userName: string = '';
  businessAreaId: number = 0;
  workFlowId: number = 0;
  wfQueueId: number = 0;
  displayName: string = '';
  fieldOrder: number = 0;
  gridType: number = 0;
  systemId: number = 0;
  doctypeId: number = 0;
}
